module.exports = __webpack_public_path__ + "img/tablist-ico01.4d5cbcf4.png";